<template>
  <p>
    <button @click="authenticate" type="button" class="btn login-facebook">
      <em v-if="parent === 'Login'" class="fab fa-facebook-f"></em>
      <em v-else class="fab fa-facebook-f"></em>
      {{buttonText}}
    </button>
  </p>
</template>

<script>
import { parseErrorMessage } from '@/utils/utils'
import {
  POST_JOB_SUCCESS
} from '@/utils/constants'
export default {
  name: 'FacebookButton',
  props: {
    buttonText: {
      type: String,
      default: 'LOGIN via FACEBOOK'
    },
    parent: {
      type: String,
      default: 'Login'
    }
  },
  methods: {
    authenticate: async function () {
      try {
        let res = await this.$auth.authenticate('facebook')
        await this.$store.dispatch('authenticateFacebook', {accessKey: res.access_token})
        await this.$store.dispatch('registerFCMDevice')
        let payloadPostJob = sessionStorage.getItem('data_post_job')
        if (payloadPostJob) {
          payloadPostJob = JSON.parse(payloadPostJob)
          delete payloadPostJob.params.employer
          await this.$store.dispatch('postCreateJob', payloadPostJob)
          sessionStorage.removeItem('data_post_job')
          this.$snotify.success(POST_JOB_SUCCESS, 'Success')
        }
        this.$router.push('jobs')
      } catch (error) {
        if (!error.message || (error.message && error.message.includes('Auth popup window closed'))) {
          return false
        } else {
          this.$snotify.error(parseErrorMessage(error), 'Error')
          const path = '/login'
          if (this.$route.path !== path) {
            this.$router.push('/login')
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/login/FacebookButton.vue